import {MomentDateFieldRange} from "../../common/date/date-range/date-field-range";
import {DashboardContext} from "../dashboard/dashboard.context";
import moment, {Moment} from "moment";

export class QuarterlyReportUtils {

    static quarterToDateRange = (reference: Moment = moment()): MomentDateFieldRange => {
        const end = reference.clone().startOf("quarter");
        const start = reference.quarter() === 1
            ? end.clone().subtract(1, "year").startOf("year")
            : end.clone().startOf("year");
        const completedQuarter = Math.max(1, end.clone().subtract(1, "day").quarter());
        const reportYear = end.clone().subtract(1, "day").year();

        return {
            label: `Quarterly report (Q${completedQuarter} ${reportYear} YTD)`,
            start,
            end
        };
    }

    static defaultRanges: MomentDateFieldRange[] = [this.quarterToDateRange(), DashboardContext.ranges.lastWeek,
        DashboardContext.ranges.thisMonth, DashboardContext.ranges.previousMonth, DashboardContext.ranges.thisYear,
        DashboardContext.ranges.previousYear, DashboardContext.ranges.lastTwelveMonths];
}
